import input from "@/assets/languages/german/input";
import button from "@/assets/languages/german/button";

const german = {
    title: 'Angebotskalkulator',
    button: button,
    input: input
}

export default german;